import { Link } from 'react-router-dom';
import EmptyState from '@/components/common/EmptyState.jsx';
import {
  CargasPage,
  CargasSection,
  CargasViewport,
  cargasButtonClassName,
} from './components/CargasLayout.jsx';

export default function ClipperPlaceholder({ title, category, backTo = '/cargas/dashboard' }) {
  const breadcrumbs = [
    { label: 'Cargas', href: '/cargas/dashboard' },
    ...(category ? [{ label: category }] : []),
    { label: title },
  ];

  return (
    <CargasPage
      title={title}
      description="Pantalla en construccion. Estamos preparando esta funcionalidad para el modulo de Cargas."
      breadcrumbs={breadcrumbs}
      hideHeaderOnCompact
      actions={
        <Link to={backTo} className={cargasButtonClassName}>
          Volver
        </Link>
      }
    >
      <CargasViewport>
        <CargasSection bodyClassName="flex items-center justify-center">
          <EmptyState
            title="Vista en construccion"
            description="Esta pantalla todavia no tiene flujo operativo definitivo. Mientras tanto podes volver al tablero de cargas."
            action={
              <Link to={backTo} className={cargasButtonClassName}>
                Volver al tablero
              </Link>
            }
          />
        </CargasSection>
      </CargasViewport>
    </CargasPage>
  );
}
